import React, { Component } from 'react'
import { Alert, Button, Col, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import { graphql } from '@apollo/client/react/hoc'
import gql from 'graphql-tag'
import moment from 'moment'
import Select from 'react-select'
import toTitleCase from '../../Functions/toTitleCase'

import withApolloClient from '../../withApolloClient'

const AllCarConditionsQuery = gql`query AddInspectionAllCarConditions($carId: ID!, $rentalId: ID) {
    allCarConditions(carId: $carId, rentalId: $rentalId, orderBy: ["-id"]) {
        edges {
            node {
                id
                pk
                dateAdded
                formType
            }
        }
    }
}`

const UpdateIncidentMutation = gql`mutation UpdateIncident($input: UpdateIncidentMutationInput!) {
    updateIncident(input: $input) {
        ok
        errors {
            field
            messages
        }
    }
}`

class AddInspectionModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedCarCondition: null,
            error: '',
            saving: false,
        }
    }

    handleClose = () => {
        this.setState({ selectedCarCondition: null, error: '', saving: false })
        this.props.handleClose && this.props.handleClose()
    }

    handleSubmit = () => {
        const { selectedCarCondition } = this.state

        if (!selectedCarCondition) {
            this.setState({ error: 'Please select an inspection.' })
            return
        }

        this.setState({ saving: true, error: '' })
        this.props.apolloClient.mutate({
            mutation: UpdateIncidentMutation,
            variables: {
                input: {
                    incidentId: this.props.incidentId,
                    carConditionId: selectedCarCondition.value,
                },
            },
        }).then((result) => {
            const response = result?.data?.updateIncident
            if (response?.ok) {
                const refetchPromise = this.props.refetchQuery ? this.props.refetchQuery() : Promise.resolve()
                return Promise.resolve(refetchPromise).catch(() => null).finally(this.handleClose)
            } else {
                const error = response?.errors?.[0]?.messages?.toString() || 'Could not add inspection to incident.'
                this.setState({ error, saving: false })
            }
        }).catch(() => {
            this.setState({ error: 'An error has occurred.', saving: false })
        })
    }

    buildInspectionOption = (edge) => {
        const date = edge.node.dateAdded ? moment(edge.node.dateAdded).tz('America/New_York').format('MMM DD, YYYY h:mm A') : '--'
        return {
            value: edge.node.id,
            label: `#${edge.node.pk} - ${edge.node.formType ? toTitleCase(edge.node.formType) : 'Inspection'} - ${date}`,
        }
    }

    render() {
        const { isOpen, conditionsLoading, allCarConditions } = this.props
        const { selectedCarCondition, error, saving } = this.state
        const inspectionOptions = allCarConditions?.edges?.map(this.buildInspectionOption) || []

        return (
            <Modal isOpen={isOpen} toggle={this.handleClose} className="incident-modal">
                <ModalHeader>Add Inspection</ModalHeader>
                <ModalBody>
                    {error && <Alert color="danger">{error}</Alert>}
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>Inspection</Label>
                                <Select
                                    className="bos-custom-select"
                                    classNamePrefix="bos-select"
                                    options={inspectionOptions}
                                    value={selectedCarCondition}
                                    onChange={(selectedCarCondition) => this.setState({ selectedCarCondition, error: '' })}
                                    placeholder="Select inspection"
                                    isLoading={conditionsLoading}
                                    isDisabled={conditionsLoading || saving}
                                    noOptionsMessage={() => conditionsLoading ? 'Loading inspections...' : 'No inspections found'}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.handleClose} disabled={saving}>Cancel</Button>
                    <Button color="primary" onClick={this.handleSubmit} disabled={saving || !selectedCarCondition}>
                        {saving ? 'Adding...' : 'Add Inspection'}
                    </Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default graphql(AllCarConditionsQuery, {
    options: (props) => ({
        variables: {
            carId: props.carId,
            rentalId: props.rentalId || null,
        },
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
    }),
    props: ({ data: { loading, allCarConditions } }) => ({
        conditionsLoading: loading,
        allCarConditions,
    }),
})(withApolloClient(AddInspectionModal))
